<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4RySAg/tc-custom/9781508082217.jpg?1705766092476" alt="This image is the cover for the book Garden at the Edge of Beyond, The Beyond Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Garden at the Edge of Beyond, The Beyond Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>A journey into a realm beyond imagination gives one man a glimpse into his own spirituality through messages of faith, hope, and love. </b><br/><br/>A man lies down for a normal night of sleep and inexplicably awakens to find himself in a surreal garden bursting with fantastic aromas and colors.<br/><br/>A succession of “tour guides’ come and go, helping him to interpret the landscape’s fragrant messages, each one a clue on the journey to discover his true self, and, ultimately, the Creator of the Country Beyond.<br/><br/><b>“One night, a 48-year-old man undergoes a truly odd experience. He awakens in a strange world, where he is able to discuss theology with such entities as a Scotsman and an Englishman, meant to be the well-known Christian theologians George MacDonald and C.S. Lewis . . . Phillips brings off this unexpected premise surprisingly well . . . a wonderful starting point for some great debate.” —<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Phillips
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bondfire Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47e27a96